'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _darken = require('../internal/darken');

var _darken2 = _interopRequireDefault(_darken);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = function root() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var active = arguments[1];
  var overrideStyle = arguments[2];

  var style = _styles2.default.root;

  var activeStyle = (0, _combineStyles2.default)(_styles2.default.root, {
    backgroundColor: color,
    ':hover': { backgroundColor: (0, _darken2.default)(color, 0.05) },
    ':active': { backgroundColor: (0, _darken2.default)(color, 0.15) }
  });

  if (active) {
    style = (0, _combineStyles2.default)(style, activeStyle);
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var text = function text() {
  var textStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var active = arguments[1];
  var textBadge = arguments[2];
  var overrideStyle = arguments[3];

  var style = textStyle;

  if (active) {
    style = (0, _combineStyles2.default)(style, { color: _colors2.default.white });
  }

  if (textBadge) {
    style = (0, _combineStyles2.default)(style, { lineHeight: '22px', marginTop: 0 });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var nestedListButton = function nestedListButton(open) {
  var style = _styles2.default.button;

  if (open) {
    style = (0, _combineStyles2.default)(style, { transform: 'rotate(180deg)' });
  }

  return style;
};

var textContainer = function textContainer(avatar, rightButton) {
  var style = _styles2.default.text;

  if (avatar) {
    style = (0, _combineStyles2.default)(style, { width: 'calc(100% - 48px)' });
  }

  if (rightButton) {
    style = (0, _combineStyles2.default)(style, { width: 'calc(100% - 40px)' });
  }

  if (avatar && rightButton) {
    style = (0, _combineStyles2.default)(style, { width: 'calc(100% - 88px)' });
  }

  return style;
};

exports.default = {
  root: root,
  text: text,
  nestedListButton: nestedListButton,
  textContainer: textContainer
};
module.exports = exports.default;